<div id="ht">
  <div id="main-cnt">

      <ion-header class="main-header block">
          <ion-toolbar class="blues-nav">
            <ion-buttons slot="start" class="nav-content">
              <div size="2" class="nav-back">
                <span class="custom-icon-back-arrow-icon" (click)="back()">
                  <span class="path1"></span>
                  <span class="path2"></span>
                </span>
                <span class="breadcrumb">AMMINISTRATORE</span>
              </div>
            </ion-buttons>
            <div slot="end" class="notification-div">
                  <ion-avatar class="menu-user-icon" (click)="openPage('/my-profile')">
                      <img [src]="session.user?.profileImg|s3Link">
                  </ion-avatar>
              </div>
          </ion-toolbar>
          <br>

          <!-- edit da qui... -->
          <img class="main-logo svg-white" src="./assets/imgs/logo-blu.svg">
          <!-- ...a qui -->
      </ion-header>


      <ion-content class="main-content">
          <div class="scroller-container">
              <div class="content-scroller">
                  <div class="content">
                      <!-- edit da qui... -->

                      <div class="menu-grid-container">
                        <div class="glass-blurred-background menu-box center-content" (click)="openPage('/users')">
                          <img class="block-image svg-white" src="./assets/imgs/utenti.svg">
                          <h2 class="text-center"><div class="wrap-text">UTENTI</div></h2>
                        </div>
                        <div class="glass-blurred-background menu-box center-content" (click)="openPage('/payments')">
                          <img class="block-image svg-white" src="./assets/imgs/pagamenti.svg">
                          <h2 class="text-center"><div class="wrap-text">PAGAMENTI</div></h2>
                        </div>
                        <div class="glass-blurred-background menu-box center-content" (click)="openPage('/report')">
                          <img class="block-image svg-white" src="./assets/imgs/report.svg">
                          <h2 class="text-center"><div class="wrap-text">REPORT</div></h2>
                        </div>
                        <div class="glass-blurred-background menu-box center-content" (click)="openPage('/contracts')">
                          <img class="block-image svg-white" src="./assets/imgs/contratti.svg">
                          <h2 class="text-center"><div class="wrap-text">CONTRATTI</div></h2>
                        </div>
                        <div class="glass-blurred-background menu-box center-content" (click)="openPage('/teams')">
                          <img class="block-image svg-white" src="./assets/imgs/squadre.svg">
                          <h2 class="text-center"><div class="wrap-text">SQUADRE</div></h2>
                        </div>
                      </div>


                          <!-- <div class="glass-blurred-background menu-box center-content">
                              <img class="block-image" src="./assets/imgs/squadre.svg">
                              <h2 class="text-center">MIA <br> <div class="wrap-text">SQUADRA</div></h2>
                          </div>
                          <div class="glass-blurred-background menu-box center-content">
                              <img class="block-image" src="./assets/imgs/clienti.svg">
                              <h2 class="text-center">MIEI <br> <div class="wrap-text">CLIENTI</div></h2>
                          </div>
                          <div class="glass-blurred-background menu-box center-content">
                              <img class="block-image" src="./assets/imgs/investimenti.svg">
                              <h2 class="text-center">MIO <br> <div class="wrap-text">INVESTIMENTO</div></h2>
                          </div>
                          <div class="glass-blurred-background menu-box center-content">
                              <img class="block-image" src="./assets/imgs/bonus.svg">
                              <h2 class="text-center">MIEI <br> <div class="wrap-text">BONUS</div></h2>
                          </div> -->

                          


                      <!-- ...a qui -->
                  </div>
              </div>
          </div>
      </ion-content>

  </div>
</div>

<!-- <ion-header>
  <ion-toolbar class="blues-nav">
    <ion-buttons slot="start" class="nav-content">      
      <div size="2" class="nav-back">
        <span class="custom-icon-back-arrow-icon" (click)="back()">
        <span class="path1"></span> <span class="path2"></span> </span>
        <span class="breadcrumb">AMMINISTRATORE</span>
      </div>            
    </ion-buttons>
    <div class="notification-div">      
      <div class="menu-user-icon" (click)="openPage('/my-profile')">

      </div>
    </div>
  </ion-toolbar>
</ion-header>

<ion-content>
  <div>
    <div class="profile-card-div">
      <ion-card class="home-card">
        <div class="home-header">
          <img src="./assets/imgs/Logo-new.png" class="whiteLogo slide-in" />
        </div>
      </ion-card>
    </div>
    <div class="home-data-card">
      <div class="dashboard-area">
        
        <ion-row class="dashboard-row">
  
          <ion-col size="6" [ngClass]="cssClass" class="dashboard-col" (click)="openPage('/users')">
            <div class="dash-widget">
              <div class="">
                <span class="ds-dashicon utenti"></span>
              </div>
              <div class="dash-widget-info">
                <p class="dash-text">Utenti</p>
              </div>
            </div>
          </ion-col>
          
          <ion-col size="6" [ngClass]="cssClass" class="dashboard-col" (click)="openPage('/payments')">
            <div class="dash-widget">
              <div class="">
                <span class="ds-dashicon pagamenti"></span>
              </div>
              <div class="dash-widget-info">
                <p class="dash-text">Pagamenti</p>
              </div>
            </div>
          </ion-col>
        
          <ion-col size="6" [ngClass]="cssClass" class="dashboard-col" (click)="openPage('/report')">
            <div class="dash-widget">
              <div class="">
                <span class="ds-dashicon report"></span>
              </div>
              <div class="dash-widget-info">
                <p class="dash-text">Report</p>
              </div>
            </div>
          </ion-col>

          <ion-col size="6" [ngClass]="cssClass" class="dashboard-col" (click)="openPage('/contracts')">
            <div class="dash-widget">
              <div class="">
                <span class="ds-dashicon contratti"></span>
              </div>
              <div class="dash-widget-info">
                <p class="dash-text">Contratti</p>
              </div>
            </div>
          </ion-col>

          <ion-col size="6" [ngClass]="cssClass" class="dashboard-col" (click)="openPage('/teams')">
            <div class="dash-widget">
              <div class="">
                <span class="ds-dashicon squadre"></span>
              </div>
              <div class="dash-widget-info">
                <p class="dash-text">Squadre</p>
              </div>
            </div>
          </ion-col>
          
        </ion-row>
        
      </div>
    </div>
  </div>
</ion-content> -->
